  <div class="row">
    <div class="col-4 text-center " *ngFor="let mediaData of mediaData; let idx = index">
      <div class="cursor-pointer" (click)="showMediaModal(idx)">
        <div class="position-relative">
          <img *ngIf="mediaData?.file_type == 'video'" class="position-absolute toast-center-center media"
            src="assets/images/grandround/play-icon.svg" width="35px" />

          <img *ngIf="mediaData?.file_type == 'document'" class="position-absolute toast-center-center media"
            src="assets/images/grandround/pdf.svg" width="35px" />

          <img *ngIf="mediaData?.file_type == 'image'" class="rounded user-150 post-pic mb-1"
            src="{{ mediaData?.file_url }}" onerror="this.src='assets/images/grandround/image_placeholder.svg'" />
          <img *ngIf=" mediaData?.file_type == 'document' ||  mediaData?.file_type == 'video' " 
              class="rounded user-150 post-pic mb-1" src="{{ mediaData?.preview_url }}"
            onerror="this.src='assets/themes/icons/media-placeholder.svg'" />
        </div>
        <p class="mb-3 secondary-paragraph">{{ mediaData?.caption }}</p>
      </div>
    </div>
  </div>
  <div *ngIf="mediaData?.length == 0" class=" paragraph-bold text-center">
    No media available
  </div>
  <app-media-modal *ngIf="mediaModal == true"
    (resetMediaModal)="setResetMediaModal($event)" [isMediaModalShown]="mediaModal" [mediaObj]="mediaObj"
    [openMediaIndex]="openMediaIndex"></app-media-modal>